var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1077,
    height: 776,
    viewBox: "0 0 1077 776",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M736.49 351.86C731.51 413.14 653.64 461.83 558.31 461.83C462.98 461.83 385.11 413.14 380.13 351.86H40V775.89H1076.62V351.86H736.49Z",
    fill: "#5C5C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1076.62 351.87L872.62 40H244L40 351.87H380.13C385.11 413.14 462.98 461.83 558.31 461.83C653.64 461.83 731.51 413.14 736.49 351.87H1076.62Z",
    fill: "#A8BCC6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1076.62 351.87L872.62 40H244L40 351.87H380.13C385.11 413.14 462.98 461.83 558.31 461.83C653.64 461.83 731.51 413.14 736.49 351.87H1076.62Z",
    fill: "#2E2E2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M784.85 636.16H324.92V563.88H784.85V636.16Z",
    fill: "#FFE5BE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M757.85 611.16H297.92V538.88H757.85V611.16Z",
    stroke: "#E5B265",
    strokeWidth: 19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M872.62 351.86V40H244V351.74L380.13 351.86C385.11 413.14 462.98 461.83 558.31 461.83C653.64 461.83 731.51 413.14 736.49 351.86H872.62Z",
    fill: "#434343"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M706.49 321.86C701.51 383.14 623.64 431.83 528.31 431.83C432.98 431.83 355.11 383.14 350.13 321.86H10V745.89H1046.62V321.86H706.49Z",
    stroke: "#E5B265",
    strokeWidth: 19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1046.62 321.86L842.62 10H214L10 321.86H350.13C355.11 383.14 432.98 431.83 528.31 431.83C623.64 431.83 701.51 383.14 706.49 321.86H1046.62Z",
    stroke: "#E5B265",
    strokeWidth: 19,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.bb646685931e6da295a0b4491f45189e.svg";
export { ForwardRef as ReactComponent };